import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const TOPMATE_URL = 'https://topmate.io/acharya_ji_ajay_l_agrawal/2021138?utm_source=public_profile&utm_campaign=acharya_ji_ajay_l_agrawal';
const ASTROLOGER_IMG = 'https://media-manager-c.questera.ai/greta-media/950656ff8acc2b4c64dfb2a5e756971f95d9a65d0f8c5ef3b6e107600fb8dee58cb5b46485e4f90e0b9e2ba9c3364607/images/aW1hZ2UvanBlZw==/662a8a4c7b7d56616839e4f9a5d8b973.jpeg';

export default function About() {
  return (
    <section id="about" className="py-24 px-6 md:px-12 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="relative"
        >
          <div className="relative rounded-sm overflow-hidden shadow-2xl border-4 border-white">
            <div className="absolute inset-0 bg-brand-dark/10 mix-blend-overlay z-10"></div>
            <img src={ASTROLOGER_IMG} alt="Acharya Ajay L Agarwal" className="w-full h-auto object-cover transform hover:scale-[1.02] transition-transform duration-700" />
          </div>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.7 }}
            className="absolute -bottom-6 -right-6 bg-brand-dark border border-brand-gold/30 shadow-xl rounded-sm px-8 py-6 z-20"
          >
            <p className="font-serif text-4xl text-brand-gold leading-none mb-2">30+</p>
            <p className="text-xs uppercase tracking-widest text-brand-light font-bold">Years of Practice</p>
          </motion.div>
          <div className="absolute -bottom-10 -left-10 w-40 h-40 border-2 border-brand-gold/20 rounded-full -z-10"></div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.9 }}
        >
          <p className="text-brand-gold text-sm uppercase tracking-[0.3em] font-bold mb-4">About Acharyaji</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-brand-dark mb-8 leading-tight">
            Decades of Jyotish & <br />
            <span className="italic text-brand-gold">Vastu in Practice.</span>
          </h2>
          <div className="space-y-6 text-stone-700 font-medium leading-relaxed text-lg md:text-xl">
            <p>
              For over three decades, Acharyaji Ajay L Agarwal has served as a trusted Vedic Astrology and Vastu advisor to business families and NRIs across 15+ countries. His clients don't come for entertainment. They come when the stakes are too high for guesswork.
            </p>
            <p>
              His methodology strips away the superstition that has diluted Jyotish in popular culture. What remains is the mathematical core: precise Dasha calculations, Ashtakavarga scoring, and Muhurta science applied directly to business decisions, investments, and Vastu corrections.
            </p>
            <p>
              Whether selecting the right time for a product launch, resolving a deadlocked family business dispute, or auditing the Vastu of a commercial property, his guidance is sought by those who understand that ancient sciences and modern strategy are not opposites.
            </p>
          </div>
          <div className="mt-12 grid grid-cols-2 gap-8 pt-10 border-t border-stone-200">
            {[{ val: '10k+', label: 'Charts Analyzed' }, { val: '15+', label: 'Countries Served' }].map((stat, i) => (
              <div key={i}>
                <p className="text-4xl font-serif text-brand-dark mb-2">{stat.val}</p>
                <p className="text-sm text-stone-500 uppercase tracking-widest font-bold">{stat.label}</p>
              </div>
            ))}
          </div>
          <div className="mt-12">
            <a
              href={TOPMATE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-10 py-5 bg-brand-dark text-brand-light hover:bg-brand-gold transition-all duration-400 rounded-sm font-bold tracking-wide text-lg shadow-lg"
            >
              Book a Session with Acharyaji
              <SafeIcon name="ArrowRight" className="text-xl" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}